// extracted by mini-css-extract-plugin
export default {"zonesNotFoundContainer":"ZonesInfoTable_zonesNotFoundContainer__nUvBs","zonesInfoTable":"ZonesInfoTable_zonesInfoTable__qA8SC"};